"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuTrigger = exports.MenuSectionHeader = exports.Menu = void 0;
var react_1 = __importStar(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var PopoverProvider_1 = require("./PopoverProvider");
var MenuContext_1 = require("./MenuContext");
var merge_refs_1 = __importDefault(require("merge-refs"));
var menuStyle = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  user-select: none;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  /* content area within popover */\n  div:nth-child(1) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"], ["\n  user-select: none;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  /* content area within popover */\n  div:nth-child(1) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"])));
var menuHeaderStyle = function (selectedTheme) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 12px 16px;\n  width: 100%;\n  /* stylelint-disable-next-line declaration-colon-newline-after */\n  border-bottom: ", " solid ", ";\n  display: block;\n  color: ", ";\n  ", ";\n  text-transform: uppercase;\n"], ["\n  padding: 12px 16px;\n  width: 100%;\n  /* stylelint-disable-next-line declaration-colon-newline-after */\n  border-bottom: ", " solid ", ";\n  display: block;\n  color: ", ";\n  ", ";\n  text-transform: uppercase;\n"])), selectedTheme === 'dark' ? '0.5px' : '1px', (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral40,
    dark: design_system_foundations_1.darkTheme.color.blueGray50,
}), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral80, dark: design_system_foundations_1.theme.color.white }), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'labelStrong'))); };
exports.Menu = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, testId = _a.testId, onKeyDown = _a.onKeyDown, rest = __rest(_a, ["children", "className", "testId", "onKeyDown"]);
    var getMenuProps = react_1.default.useContext(MenuContext_1.MenuContext).getMenuProps;
    var renderChildren = function (children) {
        return Array.isArray(children)
            ? react_1.default.Children.map(children, function (element, index) {
                // Each MenuItem needs to know the index so that it can figure out which item to highlight or disabled
                return react_1.default.isValidElement(element)
                    ? react_1.default.cloneElement(element, {
                        // @ts-ignore as know this element should have an index prop
                        index: index,
                    })
                    : undefined;
            })
            : children;
    };
    return (react_1.default.createElement("div", __assign({}, rest, getMenuProps === null || getMenuProps === void 0 ? void 0 : getMenuProps({ onKeyDown: onKeyDown }), { className: (0, css_1.cx)(menuStyle, className, 'ds-menu'), "data-testid": testId, ref: ref, role: "menu" }), react_1.default.isValidElement(children) && children.type === react_1.default.Fragment
        ? renderChildren(children.props.children)
        : renderChildren(children)));
});
exports.Menu.displayName = 'Menu';
exports.MenuSectionHeader = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, testId = _a.testId, rest = __rest(_a, ["children", "className", "testId"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    return (react_1.default.createElement("div", __assign({}, rest, { role: "menuitem", "aria-hidden": true, "data-testid": testId, className: (0, css_1.cx)(menuHeaderStyle(selectedTheme), className, 'ds-menu-header'), ref: ref }), children));
});
exports.MenuSectionHeader.displayName = 'MenuSectionHeader';
exports.MenuTrigger = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, onClick = _a.onClick, onKeyDown = _a.onKeyDown, className = _a.className, disabled = _a.disabled, rest = __rest(_a, ["children", "onClick", "onKeyDown", "className", "disabled"]);
    // May or not be in a popover menu
    var _b = react_1.default.useContext(PopoverProvider_1.PopoverContext), popoverTriggerProps = _b.popoverTriggerProps, popoverProps = _b.popoverProps;
    var getMenuTriggerProps = react_1.default.useContext(MenuContext_1.MenuContext).getMenuTriggerProps;
    var menuTriggerProps = getMenuTriggerProps === null || getMenuTriggerProps === void 0 ? void 0 : getMenuTriggerProps();
    var props = __assign(__assign(__assign(__assign({}, rest), menuTriggerProps), popoverTriggerProps), { ref: (0, merge_refs_1.default)(ref, popoverTriggerProps === null || popoverTriggerProps === void 0 ? void 0 : popoverTriggerProps.ref), onClick: !disabled
            ? function (event) {
                var _a, _b;
                (_a = menuTriggerProps === null || menuTriggerProps === void 0 ? void 0 : menuTriggerProps.onClick) === null || _a === void 0 ? void 0 : _a.call(menuTriggerProps);
                (_b = popoverTriggerProps === null || popoverTriggerProps === void 0 ? void 0 : popoverTriggerProps.onClick) === null || _b === void 0 ? void 0 : _b.call(popoverTriggerProps, event);
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            }
            : undefined, onKeyDown: !disabled
            ? function (event) {
                var _a, _b;
                (_a = menuTriggerProps === null || menuTriggerProps === void 0 ? void 0 : menuTriggerProps.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(menuTriggerProps, event);
                (_b = popoverTriggerProps === null || popoverTriggerProps === void 0 ? void 0 : popoverTriggerProps.onKeyDown) === null || _b === void 0 ? void 0 : _b.call(popoverTriggerProps, event);
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
            }
            : undefined });
    var triggerChild = null;
    if (typeof children === 'function') {
        triggerChild = children(__assign({ isOpen: popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.isOpen, onClose: popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.onClose }, props));
    }
    if (react_1.default.isValidElement(children)) {
        triggerChild = children;
    }
    if (triggerChild) {
        return react_1.default.cloneElement(triggerChild, __assign(__assign({}, props), { className: (0, css_1.cx)(className, 'ds-menu-trigger'), disabled: disabled, isDisabled: disabled }));
    }
    return null;
});
exports.MenuTrigger.displayName = 'MenuTrigger';
var templateObject_1, templateObject_2;
